var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.524536,
    y: 0.54541,
    width: 35.5245,
    height: 35.5245,
    rx: 8.88112,
    fill: "#662AB2",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2073 23.2367H17.4947C17.4069 23.2367 17.3319 23.1617 17.3319 23.0739C17.3319 22.9861 17.4069 22.9111 17.4947 22.9111H24.2073C24.2951 22.9111 24.3702 22.9861 24.3702 23.0739C24.3702 23.1656 24.2987 23.2367 24.2073 23.2367Z",
    fill: "#292D32",
    stroke: "#662AB2",
    strokeWidth: 0.888112
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2073 18.5815H17.4947C17.4069 18.5815 17.3319 18.5064 17.3319 18.4186C17.3319 18.3308 17.4069 18.2558 17.4947 18.2558H24.2073C24.2951 18.2558 24.3702 18.3308 24.3702 18.4186C24.3702 18.5064 24.2951 18.5815 24.2073 18.5815Z",
    fill: "#292D32",
    stroke: "#662AB2",
    strokeWidth: 0.888112
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2073 13.9189H17.4947C17.4069 13.9189 17.3319 13.8438 17.3319 13.756C17.3319 13.6683 17.4069 13.5932 17.4947 13.5932H24.2073C24.2951 13.5932 24.3702 13.6682 24.3702 13.756C24.3702 13.8438 24.2951 13.9189 24.2073 13.9189Z",
    fill: "#292D32",
    stroke: "#662AB2",
    strokeWidth: 0.888112
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7253 14.218L13.0393 14.532L13.3533 14.218L14.9371 12.6342C15.0005 12.5708 15.1042 12.5708 15.1676 12.6342L15.4816 12.3202L15.1676 12.6342C15.2311 12.6976 15.2311 12.8013 15.1676 12.8647L13.1607 14.8716C13.115 14.913 13.0737 14.9253 13.0393 14.9253C12.9962 14.9253 12.9532 14.9069 12.9241 14.8778L12.2506 14.2043C12.1872 14.1409 12.1872 14.0372 12.2506 13.9738C12.314 13.9103 12.4177 13.9103 12.4811 13.9738L12.7253 14.218Z",
    fill: "#292D32",
    stroke: "#662AB2",
    strokeWidth: 0.888112
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7253 18.8806L13.0393 19.1946L13.3533 18.8806L14.9371 17.2968C15.0005 17.2334 15.1042 17.2334 15.1676 17.2968L15.4816 16.9828L15.1676 17.2968C15.2311 17.3602 15.2311 17.4639 15.1676 17.5273L13.1546 19.5404C13.123 19.572 13.0821 19.5879 13.0393 19.5879C12.9966 19.5879 12.9557 19.572 12.9241 19.5404L12.2506 18.8669C12.1872 18.8035 12.1872 18.6998 12.2506 18.6364C12.314 18.5729 12.4177 18.5729 12.4811 18.6364L12.7253 18.8806Z",
    fill: "#292D32",
    stroke: "#662AB2",
    strokeWidth: 0.888112
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7253 23.3213L13.0393 23.6353L13.3533 23.3213L14.9371 21.7375C15.0005 21.6741 15.1042 21.6741 15.1676 21.7375C15.2311 21.8009 15.2311 21.9046 15.1676 21.968L13.1546 23.981C13.123 24.0127 13.0821 24.0286 13.0393 24.0286C12.9966 24.0286 12.9557 24.0127 12.9241 23.981L12.2506 23.3076C12.1872 23.2441 12.1872 23.1405 12.2506 23.077C12.314 23.0136 12.4177 23.0136 12.4811 23.077L12.7253 23.3213Z",
    fill: "#292D32",
    stroke: "#662AB2",
    strokeWidth: 0.888112
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.7622,
    height: 17.7622,
    fill: "white",
    transform: "translate(9.40546 9.42651)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.f1f35aa0f94d9daba418f151bacfe2f3.svg";
export { ForwardRef as ReactComponent };